<script setup lang="ts">
import { useProductDetailsQuery } from "~/queries/catalog/products";

definePageMeta({
  ssr: true,
  middleware: "cache-control-server",
});

const route = useRoute();
const productIdentifier = computed(
  () => route.params.productIdentifier as string,
);

const { data: product, status: productQueryStatus } = useProductDetailsQuery(
  productIdentifier,
  {
    autoRefetch: true,
    redirectNotFound: true,
    suspenseWithHydration: true,
  },
);

const { addProductPageVisit } = useAnalytics();
useTrackEventOnce(product, addProductPageVisit);

watch(
  productQueryStatus,
  (newStatus, oldStatus) => {
    if (oldStatus !== "success" && newStatus === "success") {
      window.scrollTo(0, 0);
    }
  },
  {
    immediate: true,
  },
);

useProductUpdates(product);
</script>

<template>
  <div data-cy="product-page-container">
    <BaseLoadingSpinner v-if="productQueryStatus === 'pending' || !product" />

    <div
      v-if="productQueryStatus === 'success' && product"
      class="page-container"
    >
      <ProductPageHeadTags :product="product" />

      <ProductPageContent :product="product" />

      <ProductSectionRecentlyViewedProducts :current-product-id="product.id" />
    </div>
  </div>
</template>
